module.exports = __webpack_public_path__ + "img/gaugebut.e1ef7306.png";